module.exports = __webpack_public_path__ + "img/76000.9b5fe241.svg";